module.exports = __webpack_public_path__ + "static/img/analysis2.d0a5610a.png";